class ChoiceInteraction {
  private readonly _identifier: string;
  private readonly _minChoices: number;
  private readonly _maxChoices: number;

  constructor(identifier: string, minChoices: number, maxChoices: number) {
    this._identifier = identifier;
    this._minChoices = minChoices;
    this._maxChoices = maxChoices;
  }

  get identifier(): string {
    return this._identifier;
  }

  get minChoices(): number {
    return this._minChoices;
  }

  get maxChoices(): number {
    return this._maxChoices;
  }
}

export default ChoiceInteraction;
